import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "ManageQuotations",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.MANAGE_QUOTATIONS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.MANAGE_QUOTATIONS.PERMISSIONS,
    },
    component: () =>
      import("@/modules/ManageQuotations/views/ManageQuotation.vue"),
  },
];

export default routes;
